import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emphasizeMatches' })
export class EmphasizeMatchesPipe implements PipeTransform {
  transform(value: string, emphasis: string): string {
    if (!value || !emphasis) return null;
    return value.replace(
      new RegExp(
        `(${emphasis.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')})`,
        'gi'
      ),
      '<strong>$&</strong>'
    );
  }
}
